<template>
  <div class="indexList">
    <template v-for="index in this.indexList">
      <section :key="index.id">
        <h3><router-link :to="'/index/'+index.id | lang" class="g-btn g-btn-lg g-btn-index g-btn-fw"> {{ $t('Index.'+index.id) }}</router-link></h3>
      </section>
    </template>
  </div>
</template>

<script>
import i18n from '@/i18n.js'

export default {
  props: {
    indexList: { type: Array, required: true },
  },
  filters: {
    lang (path) {
      return i18n.locale == 'en' ? '/en'+path : path
    }
  },
}
</script>
